export default function RichText({ html, className = "" }) {
  if (!html) return null;
  return <div className={`rte ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
